import { reducer } from "./reducers"
import { Selector } from "./selectors"
import { Action } from "./actions"
import { combinedEpics} from "./epics"

export const projectReducer = reducer
export const ProjectSelector = Selector
export const ProjectAction = Action
export const projectEpics = combinedEpics


// WEBPACK FOOTER //
// ./src/state/project/index.ts